module.exports = __webpack_public_path__ + "static/media/github.12baa333.png";